import { apiUrl } from '../config';
import { fetch, handleApiError } from '../utils/http';

export function fetchUsersStart() {
    return {
        type : 'USERS_FETCH_START',
    }
}

export function fetchUsersSuccess(data) {
    return {
        type : 'USERS_FETCH_SUCCESS',
        data
    }
}

export function fetchUsersFailure(error) {
    return {
        type : 'USERS_FETCH_FAILURE',
        error
    }
}

export function fetchUsers() {
    return function(dispatch) {
        dispatch(fetchUsersStart());
        const url = `${apiUrl()}/users`;
        fetch(url)
            .then(response => response.json())
            .then(json => dispatch(fetchUsersSuccess(json)))
            .catch(error => dispatch(fetchUsersFailure(error)))
    }
}

function saveUserStart() {
    return {
        type : 'USERS_SAVE_START'
    }
}

function saveUserSuccess(data) {
    return {
        type : 'USERS_SAVE_SUCCESS',
        data
    }
}

function saveUserFailure(error) {
    return {
        type : 'USERS_SAVE_FAILURE',
        error
    }
}

export function saveUser(user) {
    return (dispatch) => {
        dispatch(saveUserStart())
        let url, method;
        if(user.created_at) {
            url = `${apiUrl()}/users/${user.id}`;
            method = 'PUT';
        } else {
            url = `${apiUrl()}/users`;
            method = 'POST';
            
        }
        fetch(url, {
            method,
            headers : {
                'Content-Type' : 'application/json',
            },
            body : JSON.stringify(user)
        })
        .then(response => response.json())
        .then(json => dispatch(saveUserSuccess(json)))
        .catch(err => handleApiError(err, dispatch, saveUserFailure));
    }
}

export function clearSaveData() {
    return {
        type : 'USERS_CLEAR_SAVE_DATA'
    }
}

function deleteUserStart() {
    return {
        type : 'USER_DELETE_START'
    }
}

function deleteUserSuccess(data) {
    return {
        type : 'USER_DELETE_SUCCESS',
        data
    }
}

function deleteUserFailure(error) {
    return {
        type : 'USER_DELETE_FAILURE',
        error
    }
}

export function deleteUser(user) {
    return dispatch => {
        dispatch(deleteUserStart());
        const url = `${apiUrl()}/users/${user.id}`;
        fetch(url, {
            method : 'DELETE'
        }).then(response => response.json())
        .then(json => dispatch(deleteUserSuccess(json)))
        .catch(err => handleApiError(err, dispatch, deleteUserFailure));
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/users.js
 **/